import React, { useState, useEffect } from "react"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import * as style from "./BuieDemo.module.scss"
import Tile from "../Tile"
import { useWindowSize } from "~utils/windowResize"

const BuieDemo = ({ microcopy }) => {
  const [activeComponent, setActiveComponent] = useState('contentExplorer')
  const [width, height] = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => setIsMobile(width < 900), [width])

  const tileClickHandler = (demoElement) => {
    setActiveComponent(demoElement)
  }

  const onItemKeyDown = (e, demoElement) => {
    if (e.key === 'Enter') {
      tileClickHandler(demoElement)
    }
  }

  return (
    <section microcopy={microcopy} className={style.buieDemo}>
        {!isMobile && 
          <div className={style.column}>
            <div
              className={style.tileWrapper}
              tabIndex="0"
              onKeyDown={(e) => onItemKeyDown(e, 'contentExplorer')}
              onClick={() => tileClickHandler('contentExplorer')}
            >
            <Tile
                active={activeComponent === "contentExplorer"}
                title={microcopy.text("box_ui_elements.demoTiles.contentExplorer.title")}
            >
                <p>{microcopy.text("box_ui_elements.demoTiles.contentExplorer.description")}</p>
            </Tile>
            </div>
            <div
              className={style.tileWrapper}
              tabIndex="0"
              onKeyDown={(e) => onItemKeyDown(e, 'contentPicker')}
              onClick={() => tileClickHandler('contentPicker') }
            >
            <Tile
                active={activeComponent === "contentPicker"}
                title={microcopy.text("box_ui_elements.demoTiles.contentPicker.title")}
            >
                <p>{microcopy.text("box_ui_elements.demoTiles.contentPicker.description")}</p>
            </Tile>
            </div>
            <div
              className={style.tileWrapper}
              tabIndex="0"
              onKeyDown={(e) => onItemKeyDown(e, 'contentPreview')}
              onClick={() => tileClickHandler('contentPreview') }
            >
            <Tile
                active={activeComponent === "contentPreview"}
                title={microcopy.text("box_ui_elements.demoTiles.contentPreview.title")}
            >
                <p>{microcopy.text("box_ui_elements.demoTiles.contentPreview.description")}</p>
            </Tile>
            </div>
            <div
              className={style.tileWrapper}
              tabIndex="0"
              onKeyDown={(e) => onItemKeyDown(e, 'contentSidebar')}
              onClick={() => tileClickHandler('contentSidebar') }
            >
            <Tile
                active={activeComponent === "contentSidebar"}
                title={microcopy.text("box_ui_elements.demoTiles.contentSidebar.title")}
            >
                <p>{microcopy.text("box_ui_elements.demoTiles.contentSidebar.description")}</p>
            </Tile>
            </div>
        </div>
      }
      {isMobile && <div className={style.mobilePillWrapper}>
        <div
            tabIndex="0"
            onClick={() => tileClickHandler('contentExplorer') }
            className={`${style.mobilePill} ${activeComponent === "contentExplorer" ? style.active : ''}`}
        >
            {microcopy.text("box_ui_elements.demoTiles.contentExplorer.title")}
        </div>
        <div
            tabIndex="0"
            onClick={() => tileClickHandler('contentPicker') }
            className={`${style.mobilePill} ${activeComponent === "contentPicker" ? style.active : ''}`}
        >
            {microcopy.text("box_ui_elements.demoTiles.contentPicker.title")}
        </div>
        <div
            tabIndex="0"
            onClick={() => tileClickHandler('contentPreview') }
            className={`${style.mobilePill} ${activeComponent === "contentPreview" ? style.active : ''}`}
        >
            {microcopy.text("box_ui_elements.demoTiles.contentPreview.title")}
        </div>
        <div
            tabIndex="0"
            onClick={() => tileClickHandler('contentSidebar') }
            className={`${style.mobilePill} ${activeComponent === "contentSidebar" ? style.active : ''}`}
        >
            {microcopy.text("box_ui_elements.demoTiles.contentSidebar.title")}
        </div>
        </div>
    }
      <iframe
        data-name="contentExplorer"
        className={`${style.iframe} ${activeComponent === 'contentExplorer' ? style.active : ''}`}
        scrolling="no"
        title="Box Content Explorer"
        src="https://codepen.io/box-platform/embed/wdWWdN?default-tab=result"
        frameBorder="no"
        loading="lazy"
        allowtransparency="true"
        allowFullScreen
      >
        See the Pen
        {' '}
        <a href="https://codepen.io/box-platform/pen/wdWWdN">
          Box Content Explorer
        </a>
        {' '}
        by box (
        <a href="https://codepen.io/box-platform">@box-platform</a>
        )
        on
        <a href="https://codepen.io">CodePen</a>
        .
      </iframe>
      <iframe
        data-name="contentPicker"
        className={`${style.iframe} ${activeComponent === 'contentPicker' ? style.active : ''}`}
        scrolling="no"
        title="Box File Picker"
        src="https://codepen.io/box-platform/embed/PWPxBm?default-tab=result"
        frameBorder="no"
        loading="lazy"
        allowtransparency="true"
        allowFullScreen
      >
        See the Pen
        {' '}
        <a href="https://codepen.io/box-platform/pen/PWPxBm">
          Box File Picker
        </a>
        {' '}
        by box (
        <a href="https://codepen.io/box-platform">@box-platform</a>
        )
        on
        <a href="https://codepen.io">CodePen</a>
        .
      </iframe>
      <iframe
        data-name="contentPreview"
        className={`${style.iframe} ${activeComponent === 'contentPreview' ? style.active : ''}`}
        height="300"
        scrolling="no"
        title="Box Content Preview"
        src="https://codepen.io/box-platform/embed/rmZdjm?default-tab=result"
        frameBorder="no"
        loading="lazy"
        allowtransparency="true"
        allowFullScreen
      >
        See the Pen
        {' '}
        <a href="https://codepen.io/box-platform/pen/rmZdjm">
          Box Content Preview
        </a>
        {' '}
        by box (
        <a href="https://codepen.io/box-platform">@box-platform</a>
        )
        on
        <a href="https://codepen.io">CodePen</a>
        .
      </iframe>
      <iframe
        data-name="contentSidebar"
        className={`${style.iframe} ${activeComponent === 'contentSidebar' ? style.active : ''}`}
        height="300"
        scrolling="no"
        title="Box Content Preview With Sidebar"
        src="https://codepen.io/box-platform/embed/pqBMgM?default-tab=result"
        frameBorder="no"
        loading="lazy"
        allowtransparency="true"
        allowFullScreen
      >
        See the Pen
        {' '}
        <a href="https://codepen.io/box-platform/pen/pqBMgM">
          Box Content Preview With Sidebar
        </a>
        {' '}
        by box (
        <a href="https://codepen.io/box-platform">@box-platform</a>
        )
        on
        <a href="https://codepen.io">CodePen</a>
        .
      </iframe>
    </section>
  )
}

export default withMicrocopy(BuieDemo)
